// extracted by mini-css-extract-plugin
module.exports = {"xl":"_83c574a","l":"_574d45b","m":"_dde4737","s":"_b3f9ac6","xs":"_3a0ecbc","xxl":"_8d9a1ab","left":"_44e2b6d","right":"_dd97e3b","center":"_9243a49"};